// Libraries
import React from 'react';

// Styles
import styles from './Wizard.module.scss';

// Components
import Step0 from './components/Step0';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Finish from './components/Finish';
import Fail from './components/Fail';

// Hooks
import { UserContext } from '../../hooks';

const STEPS = [Step0, Step1, Step2];

const Wizard = () => {
  const { step, finished, fail } = React.useContext(UserContext);
  const Step = STEPS[step];

  return (
    <div className={styles.Root}>
      {
        fail ?
          <Fail /> :
          finished ?
            <Finish /> :
            Step && <Step />
      }
    </div>
  );
};

// Exports
export default Wizard;
